<div class="page-login" tabIndex="1" v-on:keyup.enter="login">
  <div class="login-block">
    <div class="title-block">
      <h1 class="title--main">{{$t('__main.__welcomePACC', {brand: brand})}}</h1>
      <h6 class="title--sub">{{$t('__main.__calibrationManagement')}}</h6>
    </div>
    <div class="desc-block">
      <p class="text">{{$t('__main.__pACCMakesColorCalibrationEasier', {brand: brand})}}</p>
      <p class="text">{{$t('__main.__logInDescribe', {brand: brand})}}</p>
    </div>
    <!-- login with asus account -->
    <!-- v-if="currentEnv === ENV.PROD" -->
    <div class="btn-block" v-if="currentEnv === ENV.PROD">
      <p class="text color--main">{{$t('__main.__signInWith')}}</p>
      <Button class="btn-single" type="full" colors="main2-gradient" :text="t('__common.__asusAccount')"
        @onClick="login" v-on:keyup.enter="login"></Button>
    </div>
    <!-- end of login with asus account  -->

    <!-- staging login -->
    <div class="ui-form-layout ui-staging-login" v-else-if="currentEnv === ENV.STAGING">
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__email')}}</div>
          <div class="form-item-block">
            <Input class="input-item" v-model:value="username"></Input>
          </div>
        </div>
      </div>
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__password')}}</div>
          <div class="form-item-block">
            <Input class="input-item" type="password" v-model:value="password"></Input>
          </div>
        </div>
      </div>
      <div class="btn-block space-out-top-base-8">
        <Button class="btn-single" type="full" colors="main2-gradient" :text="t('__common.__login')"
          v-on:keyup.enter="login" @onClick="login" :disable="isLoginDisable"></Button>
      </div>
    </div>
    <!-- end of staging login  -->

    <!-- ADC login -->
    <div class="ui-form-layout ui-adc-login" v-else-if="currentEnv === ENV.ADC">
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__email')}}</div>
          <div class="form-item-block">
            <Input class="input-item" v-model:value="username"></Input>
          </div>
        </div>
      </div>
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__password')}}</div>
          <div class="form-item-block">
            <Input class="input-item" type="password" v-model:value="password"></Input>
          </div>
        </div>
      </div>
      <div class="btn-block space-out-top-base-8">
        <Button class="btn-single" type="full" colors="main2-gradient" :text="t('__common.__login')"
          v-on:keyup.enter="login" @onClick="login" :disable="isLoginDisable"></Button>
      </div>
    </div>
    <!-- end of ADC login -->

    <!-- other environments (dev, mock, etc.) -->
    <div class="ui-form-layout ui-staging-login" v-else>
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__email')}}</div>
          <div class="form-item-block">
            <Input class="input-item" v-model:value="username"></Input>
          </div>
        </div>
      </div>
      <div class="ui-form-grid-row">
        <div class="ui-form-grid-col-12 align-left">
          <div class="form-title-block ">{{$t('__common.__password')}}</div>
          <div class="form-item-block">
            <Input class="input-item" type="password" v-model:value="password"></Input>
          </div>
        </div>
      </div>
      <div class="btn-block space-out-top-base-8">
        <Button class="btn-single" type="full" colors="main2-gradient" :text="t('__common.__login')"
          v-on:keyup.enter="login" @onClick="login" :disable="isLoginDisable"></Button>
      </div>
    </div>
    <!-- end of other environments -->


  </div>
</div>